var CDropdownView = Backbone.View.extend({

    tagName: 'select',

    events:
    {
        change: '_onChange'
    },

    initialize: function( options )
    {
        if (!this.collection)
        {
            throw new Error('Dropdown needs a collection');
        }

        this.valueField = options.valueField || 'value';
        this.textField = options.textField || 'text';
        this.placeholder = options.placeholder || null;
        this.newOption = options.newOption || null;
        this.selectedId = null;

        this.listenTo(this.collection, 'reset add remove', this.render);

        if ( options.doFetch )
        {
            this.collection.fetch({ reset: true });
        }

    },

    setValue: function(strValue)
    {
        this.$el.val(strValue);
        this.selectedId = this.$el.find('[value="'+strValue+'"]').attr('data-id') || null;
    },

    render: function()
    {
        this.$el.html('');

        if ( this.placeholder )
        {
            this.$el.append('<option>' + this.placeholder + '</option>')
        }

        if ( this.newOption )
        {
            this.$el.append('<option value="new">New</option>');
        }

        _.each(this.collection.models, function( item ){
            this.$el.append(
                new CDropdownItemView({
                    model: item,
                    valueField: this.valueField,
                    textField: this.textField,
                    selected: item.id === this.selectedId
                }).render().el
            );
        },this);

        this.trigger('rendered');
        return this;
    },

    /**
     * @param objEvent
     * @private
     */
    _onChange: function(objEvent)
    {
        this.selectedId = $(objEvent.currentTarget).attr('data-id') || null;
    }
});
